export default __webpack_public_path__ + "static/media/articalSecond.404f2689.png";